<template>
  <li class="treeview-item" :class="{ 'treeview-item--selected': selected }">
    <slot />
  </li>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AppTreeviewItem',
  inheritAttrs: true,
  props: {
    selected: {
      type: Boolean,
      default: false,
    },
  },
})
</script>

<style scoped lang="scss">
@import "@/scss/border-tokens";

.treeview-item {
  padding: 8px 12px;
  @include border-radius('border-radius-3');

  &:hover {
    background: rgba(var(--v-theme-surface-hover));
  }

  &--selected {
    background: rgb(var(--v-theme-surface-brand));

    &:hover {
      background:
        linear-gradient(rgba(var(--v-theme-surface-hover)), rgba(var(--v-theme-surface-hover)))
        rgb(var(--v-theme-surface-brand));
    }
  }
}
</style>
